<template>
    <div id="billing">
        <AppBreadCrumb
            :show-trial-remain-day="true"
            :paths="[{ title: $t('billing.billingPlanSettings') }]"
            :select="true"
        >
            <a-button v-if="isAdmin" v-b-modal.invoice-form class="actionButtonBreadcrumb">
                {{ $t("billing.newInvoice") }}
            </a-button>
        </AppBreadCrumb>
        <b-container fluid>
            <DefaultBillingSettings />
        </b-container>

        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import { log2 } from "../../utils/log2";
import ChatBar from "../../components/ChatBar";
import DefaultBillingSettings from "../../components/billing/DefaultBillingSettings";
import * as _ from "lodash";
import ShopifyBillingDetails from "../../components/billing/ShopifyBillingDetails";

const log = log2("Billing");
export default {
    name: "Billing",
    components: {
        AppBreadCrumb,
        ChatBar,
        DefaultBillingSettings,
        ShopifyBillingDetails,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            languages: (state) => state.language.languages,
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
            isShopify: (state) => _.get(state.site.site, "partner.name") === "shopify",
            isAdmin: (state) => state.auth.adminUser != null,
        }),
    },
    updated() {
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
};
</script>
